import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class SignatureRequest extends AbstractModel {
  @autoserialize
  tncDriverProfileId: number;

  @autoserialize
  signatureRequestId: string;

  @autoserializeAs(Date)
  signedDate: Date;

  @autoserialize
  isSigned: boolean;
}
